import React from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as actions from '../../store/actions/InterviewInviteActions';
import styles from './InterviewerLoginForm.scss';
import { connect } from 'react-redux';
import { loginInterviewRequest } from '../../store/actions/AuthActions';

const InterviewerLoginForm = ({ loginHandler, startInterview, interview_id }) => {
  const [form] = Form.useForm();

  const onFinish = values => {
    let payload = {
      emailId: values.email,
      password: values.password,
      callback: () => startInterview(interview_id),
    };
    loginHandler(payload);
  };

  return (
    <Form
      form={form}
      className={styles.form}
      onFinish={onFinish}
      initialValues={{ remember: true }}
      layout="vertical"
    >
      <Form.Item
        name="email"
        rules={[{ required: true, message: 'Please input your Email!' }]}
      >
        <Input
          prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder="Username"
        />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: 'Please input your Password!' }]}
      >
        <Input.Password
          prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder="Password"
        />
      </Form.Item>
      <Form.Item>
        <Form.Item
          name="remember"
          valuePropName="checked"
          noStyle
        >
          <Checkbox>Keep me signed</Checkbox>
        </Form.Item>
        <Link
          className={styles['form__forgot']}
          to="#"
        >
          Forgot Password?
        </Link>
        <Button
          type="primary"
          htmlType="submit"
          className={styles['form__button']}
          block
        >
          Log in
        </Button>
      </Form.Item>
    </Form>
  );
};

const mapStateToProps = state => ({
  interview_id: state.interview.interview_id,
});

const mapDispatchToProps = dispatch => ({
  loginHandler: values => dispatch(loginInterviewRequest(values)),
  startInterview: interview_id => dispatch(actions.startInterview(interview_id)),
});

InterviewerLoginForm.propTypes = {
  loginHandler: PropTypes.func,
  startInterview: PropTypes.func,
  interview_id: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(InterviewerLoginForm);
